var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF3F2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0702 21.23C35.4602 21.07 33.8502 20.95 32.2302 20.86V20.85L32.0102 19.55C31.8602 18.63 31.6402 17.25 29.3002 17.25H26.6802C24.3502 17.25 24.1302 18.57 23.9702 19.54L23.7602 20.82C22.8302 20.88 21.9002 20.94 20.9702 21.03L18.9302 21.23C18.5102 21.27 18.2102 21.64 18.2502 22.05C18.2902 22.46 18.6502 22.76 19.0702 22.72L21.1102 22.52C26.3502 22 31.6302 22.2 36.9302 22.73C36.9602 22.73 36.9802 22.73 37.0102 22.73C37.3902 22.73 37.7202 22.44 37.7602 22.05C37.7902 21.64 37.4902 21.27 37.0702 21.23Z",
    fill: "#E1004B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2302 24.14C34.9902 23.89 34.6602 23.75 34.3202 23.75H21.6802C21.3402 23.75 21.0002 23.89 20.7702 24.14C20.5402 24.39 20.4102 24.73 20.4302 25.08L21.0502 35.34C21.1602 36.86 21.3002 38.76 24.7902 38.76H31.2102C34.7002 38.76 34.8402 36.87 34.9502 35.34L35.5702 25.09C35.5902 24.73 35.4602 24.39 35.2302 24.14ZM29.6602 33.75H26.3302C25.9202 33.75 25.5802 33.41 25.5802 33C25.5802 32.59 25.9202 32.25 26.3302 32.25H29.6602C30.0702 32.25 30.4102 32.59 30.4102 33C30.4102 33.41 30.0702 33.75 29.6602 33.75ZM30.5002 29.75H25.5002C25.0902 29.75 24.7502 29.41 24.7502 29C24.7502 28.59 25.0902 28.25 25.5002 28.25H30.5002C30.9102 28.25 31.2502 28.59 31.2502 29C31.2502 29.41 30.9102 29.75 30.5002 29.75Z",
    fill: "#E1004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon);
export default __webpack_public_path__ + "static/media/delete-modal-icon.e9b1a58dd6d63fb823362d29761f616f.svg";
export { ForwardRef as ReactComponent };